import script from "./AuditLogsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./AuditLogsScreen.vue?vue&type=script&setup=true&lang=js"

import "./AuditLogsScreen.vue?vue&type=style&index=0&id=66f6e174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66f6e174"]])

export default __exports__